import React from 'react';
import { useParams } from 'react-router-dom';
import { ChevronLeft, Plus } from 'lucide-react';
import ComposeModal from '../components/ComposeModal';
import ChannelSelector from '../components/ChannelSelector';
import MessageBubble from '../components/MessageBubble';

// Mock data; each message must match MessageBubbleProps shape
const mockMessages: {
  id: string;
  sender: string;
  role: 'staff' | 'student';
  body: string;
  timestamp: string;
  channel: 'in_platform' | 'email' | 'sms';
}[] = [
  { id: '1', sender: 'You', role: 'staff', body: 'Hello everyone!', timestamp: '10:00 AM', channel: 'in_platform' },
  { id: '2', sender: 'Alice Johnson', role: 'student', body: 'Hi, thanks for the update.', timestamp: '10:05 AM', channel: 'email' },
  { id: '3', sender: 'Bob Smith', role: 'student', body: 'Got it!', timestamp: '10:10 AM', channel: 'sms' },
];

export default function ThreadView() {
  const { threadId } = useParams();
  const [showCompose, setShowCompose] = React.useState(false);

  const threadTitle = `Thread ${threadId}`;

  const hasStudent = mockMessages.some((m) => m.role === 'student');

  return (
    <div className="flex flex-col h-full bg-white dark:bg-gray-900">
      <div className="flex items-center border-b px-4 py-3">
        <button onClick={() => window.history.back()} className="p-1">
          <ChevronLeft />
        </button>
        <h3 className="ml-2 text-lg font-semibold flex-1">{threadTitle}</h3>
        <ChannelSelector />
        <button
          onClick={() => setShowCompose(true)}
          className="ml-4 p-1 text-primary hover:text-primary/80"
        >
          <Plus />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-4 space-y-4">
        {mockMessages.map((msg) => (
          <MessageBubble key={msg.id} {...msg} />
        ))}
      </div>
      <div className="border-t px-4 py-3">
        {hasStudent && (
          <div className="mb-2 rounded bg-yellow-100 px-4 py-2 text-sm text-yellow-800">
            ⚠️ This conversation includes students; please keep the tone appropriate.
          </div>
        )}
        <ChannelSelector />
        <div className="mt-2 flex gap-2">
          <textarea
            placeholder="Type your message..."
            className="flex-1 resize-none rounded-md border px-3 py-2 focus:outline-hidden focus:ring-2 focus:ring-primary"
          />
          <button className="rounded bg-primary px-4 py-2 text-white">Send</button>
        </div>
      </div>
      {showCompose && <ComposeModal threadId={threadId} onClose={() => setShowCompose(false)} />}
    </div>
  );
}